import { useCallback } from 'react'
import { getSdk } from '../utils/sdk'

export const useGetBitpayInvoice = () => {
  const getBitpayInvoice = useCallback(() => getSdk().getBitpayInvoice(), [])

  return { getBitpayInvoice }
}
